import { useEffect, useState, useContext, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import AssessmentHeadIcon from "../../../../assets/icons/AssessmentHead.svg";
import CreatedUserIcon from "../../../../assets/icons/CreatedUser.svg";
import ATSessionsIcon from "../../../../assets/icons/ATSessions.svg";
import TopicService from "../../../../services/TopicService";
import AuthContext from "../../../../auth/AuthContext";


const MasterQuizCard = () => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  const [quizzes, setQuizzes] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchQuizzes = useCallback(async () => {
    try {
      setLoading(true);
      const res = await TopicService.GetAllVideos(authContext);

      if (res?.isSuccess && Array.isArray(res?.data)) {
        setQuizzes(res.data);
      } else {
        setQuizzes([]);
      }
    } catch (err) {
      console.error('Failed to fetch quizzes', err);
      setQuizzes([]);
    } finally {
      setLoading(false);
    }
  }, [authContext]);

  useEffect(() => {
    fetchQuizzes();
  }, [fetchQuizzes]);

     if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="bg-white dark:bg-slate-900 rounded-xl shadow p-5 flex flex-col h-full animate-pulse"
          >
            {/* Header */}
            <div className="flex items-center gap-3 min-h-[72px]">
              <div className="w-12 h-12 rounded-full bg-gray-300 dark:bg-slate-700" />

              <div className="flex-1 space-y-2">
                <div className="h-4 w-11/12 bg-gray-300 dark:bg-slate-700 rounded" />
                <div className="h-4 w-8/12 bg-gray-300 dark:bg-slate-700 rounded" />
              </div>
            </div>

            {/* Progress */}
            <div className="mt-3">
              <div className="h-2 w-full bg-gray-300 dark:bg-slate-700 rounded-full" />
            </div>

            {/* Attendees */}
            <div className="flex justify-between mt-2 mb-4">
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-gray-300 dark:bg-slate-700" />
                <div className="h-3 w-12 bg-gray-300 dark:bg-slate-700 rounded" />
              </div>

              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-gray-300 dark:bg-slate-700" />
                <div className="h-3 w-12 bg-gray-300 dark:bg-slate-700 rounded" />
              </div>
            </div>

            {/* Button */}
            <div className="h-10 w-full bg-gray-300 dark:bg-slate-700 rounded-full mt-auto" />
          </div>
        ))}
      </div>
    );
  }


if (quizzes.length === 0) {
  return (
    <div className="w-full flex items-center justify-center py-20">
      <p className="text-lg text-gray-500 dark:text-gray-400">
        No Quizzes available
      </p>
    </div>
  );
}


  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {quizzes.map((item) => (
        <div key={item.id} className="flex">
          <div
            className="
              flex flex-col h-full w-full
              rounded-xl p-5 shadow
              bg-white text-gray-900
              dark:bg-slate-900 dark:text-gray-100
            "
          >
            <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
              <img
                src={AssessmentHeadIcon}
                alt="Quiz"
                className="w-10 h-10"
              />
              <h6 className="font-medium leading-snug line-clamp-2">
                {item.name}
              </h6>
            </div>
            </div>

            <div className=" w-full h-[3px] rounded-full p-[0.5px]
              bg-gradient-to-r from-teal-500 to-blue-600
              dark:from-cyan-400 dark:to-indigo-500" />

            <div className="flex justify-between items-center mt-5 text-base">
              <button
             onClick={() =>
                  navigate(`/masters-quizzes/${item.id}/attendees`, {
                    state: { quizName: item.name },
                  })
                }
                className="flex items-center gap-2 underline"
              >
                <img src={CreatedUserIcon} alt="user" className="w-5 h-5" />
                Attendees
              </button>

              <button
                  onClick={() =>
                  navigate(`/masters-quizzes/${item.id}/sessions`, {
                    state: { quizName: item.name },
                  })
                }
                className="flex items-center gap-2 underline"
              >
                <img src={ATSessionsIcon} alt="sessions" className="w-5 h-5" />
                Sessions
              </button>
            </div>

            <div className="mt-auto pt-5">
              <button
                  onClick={() =>
                  navigate(`/masters-quizzes/${item.id}/questions`, {
                    state: { quizName: item.name },
                  })
                }
                className="
                  w-full px-5 py-2 rounded-full border
                  border-gray-900 dark:border-gray-200
                  text-base font-medium transition
                  hover:bg-gray-900 hover:text-white
                  dark:hover:bg-white dark:hover:text-black
                "
              >
                Upload Questions
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MasterQuizCard;